/**
 * @fileoverview gRPC-Web generated client stub for productupdates
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: productupdates/productupdates.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.productupdates = require('./productupdates_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.productupdates.ProductUpdatesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.productupdates.ProductUpdatesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.GetReleaseNotesRequest,
 *   !proto.productupdates.GetReleaseNotesResponse>}
 */
const methodDescriptor_ProductUpdatesService_GetReleaseNotes = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/GetReleaseNotes',
  grpc.web.MethodType.UNARY,
  proto.productupdates.GetReleaseNotesRequest,
  proto.productupdates.GetReleaseNotesResponse,
  /**
   * @param {!proto.productupdates.GetReleaseNotesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.GetReleaseNotesResponse.deserializeBinary
);


/**
 * @param {!proto.productupdates.GetReleaseNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.GetReleaseNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.GetReleaseNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.getReleaseNotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetReleaseNotes',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetReleaseNotes,
      callback);
};


/**
 * @param {!proto.productupdates.GetReleaseNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.GetReleaseNotesResponse>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.getReleaseNotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetReleaseNotes',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetReleaseNotes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.GetComingSoonRequest,
 *   !proto.productupdates.GetComingSoonResponse>}
 */
const methodDescriptor_ProductUpdatesService_GetComingSoon = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/GetComingSoon',
  grpc.web.MethodType.UNARY,
  proto.productupdates.GetComingSoonRequest,
  proto.productupdates.GetComingSoonResponse,
  /**
   * @param {!proto.productupdates.GetComingSoonRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.GetComingSoonResponse.deserializeBinary
);


/**
 * @param {!proto.productupdates.GetComingSoonRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.GetComingSoonResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.GetComingSoonResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.getComingSoon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetComingSoon,
      callback);
};


/**
 * @param {!proto.productupdates.GetComingSoonRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.GetComingSoonResponse>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.getComingSoon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetComingSoon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.GetAppVersionRequest,
 *   !proto.productupdates.GetAppVersionResponse>}
 */
const methodDescriptor_ProductUpdatesService_GetAppVersion = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/GetAppVersion',
  grpc.web.MethodType.UNARY,
  proto.productupdates.GetAppVersionRequest,
  proto.productupdates.GetAppVersionResponse,
  /**
   * @param {!proto.productupdates.GetAppVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.GetAppVersionResponse.deserializeBinary
);


/**
 * @param {!proto.productupdates.GetAppVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.GetAppVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.GetAppVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.getAppVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetAppVersion',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetAppVersion,
      callback);
};


/**
 * @param {!proto.productupdates.GetAppVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.GetAppVersionResponse>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.getAppVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetAppVersion',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetAppVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.ReleaseNote,
 *   !proto.productupdates.ReleaseNote>}
 */
const methodDescriptor_ProductUpdatesService_CreateReleaseNote = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/CreateReleaseNote',
  grpc.web.MethodType.UNARY,
  proto.productupdates.ReleaseNote,
  proto.productupdates.ReleaseNote,
  /**
   * @param {!proto.productupdates.ReleaseNote} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.ReleaseNote.deserializeBinary
);


/**
 * @param {!proto.productupdates.ReleaseNote} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.ReleaseNote)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.ReleaseNote>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.createReleaseNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/CreateReleaseNote',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_CreateReleaseNote,
      callback);
};


/**
 * @param {!proto.productupdates.ReleaseNote} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.ReleaseNote>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.createReleaseNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/CreateReleaseNote',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_CreateReleaseNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.ReleaseNote,
 *   !proto.productupdates.ReleaseNote>}
 */
const methodDescriptor_ProductUpdatesService_UpdateReleaseNote = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/UpdateReleaseNote',
  grpc.web.MethodType.UNARY,
  proto.productupdates.ReleaseNote,
  proto.productupdates.ReleaseNote,
  /**
   * @param {!proto.productupdates.ReleaseNote} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.ReleaseNote.deserializeBinary
);


/**
 * @param {!proto.productupdates.ReleaseNote} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.ReleaseNote)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.ReleaseNote>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.updateReleaseNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateReleaseNote',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateReleaseNote,
      callback);
};


/**
 * @param {!proto.productupdates.ReleaseNote} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.ReleaseNote>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.updateReleaseNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateReleaseNote',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateReleaseNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.DeleteReleaseNoteRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ProductUpdatesService_DeleteReleaseNote = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/DeleteReleaseNote',
  grpc.web.MethodType.UNARY,
  proto.productupdates.DeleteReleaseNoteRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.productupdates.DeleteReleaseNoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.productupdates.DeleteReleaseNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.deleteReleaseNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/DeleteReleaseNote',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_DeleteReleaseNote,
      callback);
};


/**
 * @param {!proto.productupdates.DeleteReleaseNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.deleteReleaseNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/DeleteReleaseNote',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_DeleteReleaseNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.UpdateOrderRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ProductUpdatesService_UpdateReleaseNotesOrder = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/UpdateReleaseNotesOrder',
  grpc.web.MethodType.UNARY,
  proto.productupdates.UpdateOrderRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.productupdates.UpdateOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.productupdates.UpdateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.updateReleaseNotesOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateReleaseNotesOrder',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateReleaseNotesOrder,
      callback);
};


/**
 * @param {!proto.productupdates.UpdateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.updateReleaseNotesOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateReleaseNotesOrder',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateReleaseNotesOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.ComingSoonItem,
 *   !proto.productupdates.ComingSoonItem>}
 */
const methodDescriptor_ProductUpdatesService_CreateComingSoon = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/CreateComingSoon',
  grpc.web.MethodType.UNARY,
  proto.productupdates.ComingSoonItem,
  proto.productupdates.ComingSoonItem,
  /**
   * @param {!proto.productupdates.ComingSoonItem} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.ComingSoonItem.deserializeBinary
);


/**
 * @param {!proto.productupdates.ComingSoonItem} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.ComingSoonItem)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.ComingSoonItem>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.createComingSoon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/CreateComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_CreateComingSoon,
      callback);
};


/**
 * @param {!proto.productupdates.ComingSoonItem} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.ComingSoonItem>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.createComingSoon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/CreateComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_CreateComingSoon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.ComingSoonItem,
 *   !proto.productupdates.ComingSoonItem>}
 */
const methodDescriptor_ProductUpdatesService_UpdateComingSoon = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/UpdateComingSoon',
  grpc.web.MethodType.UNARY,
  proto.productupdates.ComingSoonItem,
  proto.productupdates.ComingSoonItem,
  /**
   * @param {!proto.productupdates.ComingSoonItem} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.ComingSoonItem.deserializeBinary
);


/**
 * @param {!proto.productupdates.ComingSoonItem} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.ComingSoonItem)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.ComingSoonItem>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.updateComingSoon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateComingSoon,
      callback);
};


/**
 * @param {!proto.productupdates.ComingSoonItem} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.ComingSoonItem>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.updateComingSoon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateComingSoon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.DeleteComingSoonRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ProductUpdatesService_DeleteComingSoon = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/DeleteComingSoon',
  grpc.web.MethodType.UNARY,
  proto.productupdates.DeleteComingSoonRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.productupdates.DeleteComingSoonRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.productupdates.DeleteComingSoonRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.deleteComingSoon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/DeleteComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_DeleteComingSoon,
      callback);
};


/**
 * @param {!proto.productupdates.DeleteComingSoonRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.deleteComingSoon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/DeleteComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_DeleteComingSoon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.UpdateOrderRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ProductUpdatesService_UpdateComingSoonOrder = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/UpdateComingSoonOrder',
  grpc.web.MethodType.UNARY,
  proto.productupdates.UpdateOrderRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.productupdates.UpdateOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.productupdates.UpdateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.updateComingSoonOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateComingSoonOrder',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateComingSoonOrder,
      callback);
};


/**
 * @param {!proto.productupdates.UpdateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.updateComingSoonOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/UpdateComingSoonOrder',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_UpdateComingSoonOrder);
};


module.exports = proto.productupdates;

